import { render } from "./MobileApps.vue?vue&type=template&id=33c46ee8&scoped=true"
import script from "./MobileApps.vue?vue&type=script&lang=js"
export * from "./MobileApps.vue?vue&type=script&lang=js"

import "./MobileApps.vue?vue&type=style&index=0&id=33c46ee8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c46ee8"]])

export default __exports__